module.exports = __webpack_public_path__ + "img/activity-6.443171a6.jpg";